export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-2 bg-background text-center">
      <h1 className="font-display text-3xl font-bold">404</h1>
      <p className="text-sm text-muted-foreground">That page does not exist.</p>
    </div>
  );
}
